import { render, staticRenderFns } from "./ChargebackShow.vue?vue&type=template&id=4e96c41c"
import script from "./ChargebackShow.vue?vue&type=script&lang=js"
export * from "./ChargebackShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports